import './styles/index.css'
import { App } from './app'

// Dev aid: `?timer-raf` drives frames with timers instead of requestAnimationFrame,
// so the scene keeps rendering in hidden/background previews (headless screenshots).
if (import.meta.env.DEV && new URLSearchParams(location.search).has('timer-raf')) {
  window.requestAnimationFrame = (callback) => window.setTimeout(() => callback(performance.now()), 16)
  window.cancelAnimationFrame = (id) => window.clearTimeout(id)
  const style = document.createElement('style')
  style.textContent = '*, *::before, *::after { transition-duration: 0s !important; }'
  document.head.append(style)
}

const app = new App()
if (import.meta.env.DEV) Object.assign(window, { __craft: app })
void app.start()
